import { Theme } from '@emotion/react';

export const generateSectionTitleStyles = (theme: Theme) => ({
    title: {
        fontFamily: theme.palette.common.font,
        fontSize: '16px',
        textTransform: 'capitalize',
        fontWeight: 500,
        letterSpacing: 0,
    },
});
